<template>
  <TheButton class="c-back-button"
    :href="`/${type}/${slug}`"
    :title="`${$t('BACK_BUTTON_LINK')}  ${name}`">
    <i class="arrow"></i>
  </TheButton>
</template>

<script>
import TheButton from '@forlagshuset/v-button'

export default {
  components: {
    TheButton
  },

  props: {
    type: String,
    slug: String,
    name: String
  }
}
</script>

<style lang="scss">

</style>
